import { BASE_URL } from '@/services/api'
import {request, METHOD} from '@/utils/request'

let MONITOR_SAVE_LOG= `${BASE_URL}/monitor/saveLog`

export async function SaveMonitorLog(params) {
  return request(MONITOR_SAVE_LOG, METHOD.POST, params)
}

export default {
}
